import { QuickStatsCard } from "@features/cx/shared/components/QuickStatsCard";
import { Tabs } from "@shared/ui/tabs";
import {
  AlertTriangle,
  Calculator,
  DollarSign,
  FileText,
  Receipt,
  TrendingUp,
} from "lucide-react";
import { useHistorySummary } from "../hooks";
import { BulkBillTab } from "./bulkBillTab";
import { SingleBillTab } from "./singleBillTab";

const Landing = () => {
  const billingTabComponents = {
    "single-bill": {
      label: "Single Bill",
      icon: <FileText className="h-4 w-4" />,
      component: <SingleBillTab />, // This component now includes subtabs internally
    },
    "bulk-bill": {
      label: "Bulk Bill",
      icon: <Receipt className="h-4 w-4" />,
      component: <BulkBillTab />,
    },
  };

  const { data: historySummary } = useHistorySummary();
  const singleBillKpiCards = [
    {
      title: "Total Outstanding Amount",
      count: historySummary?.totalOutstandingBalance,
      trendSummary: "Sum of overdue & unpaid invoices",
      icon: <DollarSign className="h-8 w-8 text-red-500" />,
    },
    {
      title: "Collection Rate",
      count: historySummary?.collectionRate,
      trendSummary: "Percentage of paid invoices",
      icon: <TrendingUp className="h-8 w-8 text-green-500" />,
    },
    {
      title: "Total Overdues",
      count: historySummary?.overDueBillsCount,
      trendSummary: "Number of overdue invoices",
      icon: <AlertTriangle className="h-8 w-8 text-orange-500" />,
    },
    {
      title: "Total Revenue Generated",
      count: historySummary?.totalPaidAmount,
      trendSummary: "Sum of all invoices",
      icon: <Calculator className="h-8 w-8 text-blue-500" />,
    },
  ];

  return (
    <div className="">
      <div className="">
        <div className="mb-4">
          <h1 className="page-title">
            Billing History
          </h1>
          <p className="page-subtitle">
            Track and manage your billing history across single bills and bulk
            operations
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4 mb-6 sm:mb-8">
          {singleBillKpiCards.map((card, index) => (
            <QuickStatsCard
              key={index}
              title={card.title}
              count={card.count}
              trendSummary={card.trendSummary}
              icon={card.icon}
              trendDirection={"up"}
            />
          ))}
        </div>

        <div className="p-2">
          <Tabs
            tabComponents={billingTabComponents}
            defaultValue="single-bill"
            urlMapping={{
              "single-bill": "single",
              "bulk-bill": "bulk",
            }}
            tabsListClassName="w-full grid grid-cols-2 bg-muted/30 p-1"
            idPrefix="billing-tab"
            level={0} // Main level tabs
          />
        </div>
      </div>
    </div>
  );
};

export default Landing;
